import { Button } from 'components/common/Button'
import { Icon } from 'components/common/Icon'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import { useRouter } from 'next/router'
import Skeleton from 'react-loading-skeleton'
import { Artist } from 'utils/data'
import { getArtistUrl } from 'utils/urls'

export type ArtistHeaderCardProps = {
  artist?: Artist
  isFetching: boolean
  index: number
}

export const ArtistHeaderCard = ({
  artist,
  isFetching,
  index,
}: ArtistHeaderCardProps) => {
  const { t } = useTranslation()
  const router = useRouter()

  const handleArtistClick = () => {
    router.push({
      pathname: getArtistUrl(artist?.name as string, artist?.id as number),
      query: {},
    })
  }

  return (
    <div
      key={artist?.id}
      className={`} group flex cursor-pointer items-center
      justify-between ${
        (index === 2 || index === 5 || index === 8) && 'md-lg:hidden '
      }`}
      onClick={handleArtistClick}
    >
      <div className='flex justify-start'>
        <div className='mr-3 aspect-1 h-[64px] w-[64px] overflow-hidden rounded-full'>
          {isFetching ? (
            <div className='h-full w-full'>
              <Skeleton className='h-full w-full rounded-full' />
            </div>
          ) : (
            <Image
              src={(artist?.avatar?.url || artist?.profile?.url) as string}
              alt={artist?.name as string}
              width={260}
              height={260}
              className='aspect-1 h-full w-full rounded-full object-cover object-center transition-transform duration-300 ease-in-out group-hover:scale-[1.2] lg:block'
            />
          )}
        </div>

        <div className='flex flex-col justify-center'>
          <div>{artist?.name ?? ''}</div>
          <div className='text-sm text-cool-600'>
            {artist?.nationalities?.map(n => n.name).join(', ') ?? ''}, b.{' '}
            {artist?.birthYear}
          </div>
        </div>
      </div>
      <Button
        pill
        style='solid-white'
        className='h-[38px] w-[128px] border-none'
        onClick={handleArtistClick}
      >
        {artist?.numberOfArtworks} {t('artists:works')}
        <Icon name='forward-arrow' size={16} className='pl-6' />
      </Button>
    </div>
  )
}
